import styled from 'styled-components';
import { PageContainer } from 'design-system/src/components/PageContainer';
import { Typography } from 'design-system/src/components/Typography/Typography';

const MessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  padding: 2rem;
  text-align: center;
`;

export type FormRevokedProps = {
  /**
   * Class name for additional styling; used to pass down styles when using inheritance in styled components
   */
  className?: string;
  /**
   * The message to display to the user
   */
  message: string;
};

/**
 * Component to display when a form has been revoked and shows a custom message.
 */
export function FormRevoked({ className, message }: FormRevokedProps) {
  return (
    <PageContainer $background="light" $navbarPlacement="top" className={className}>
      <MessageContainer>
        <Typography styledAs="body1" color="text.secondary" style={{ maxWidth: '600px', lineHeight: '1.6' }}>
          {message}
        </Typography>
      </MessageContainer>
    </PageContainer>
  );
}

export default FormRevoked;
